export interface ProfileFlagReason {
  key: string;
  id: number;
}

export const PROFILE_FLAG_REASONS: ReadonlyArray<ProfileFlagReason> = [
  { key: 'inappropriateOffensive', id: 1 },
  { key: 'misleadingSuspicious', id: 2 },
  { key: 'poorExperience', id: 3 },
  { key: 'discriminatory', id: 5 },
  { key: 'other', id: 4 },
];
